import {
  LdsButton,
  LdsSearch,
  LdsSelect,
  LdsToast,
  useToastContext,
} from "@elilillyco/ux-lds-react";

import "./../../assets/scss/overview/createListModal.scss";
import { useEffect, useState } from "react";
import {
  FETCH_THPC_DATA,
  CREATE_LIST,
} from "../../store/createList";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const EditBrandIndication = ({
  modalType,
  closeBrandIndicationEdit,
  saveMetaData,
}) => {
  const dispatch = useDispatch();
  useToastContext();
  const navigate = useNavigate();

  const { thpcdata } = useSelector(({ createlist }) => createlist);
  const { uuid } = useSelector(({ user }) => user);
  const { specialtyList } = useSelector(({ details }) => details);
  console.log("specialtyList", specialtyList);
  const [selectedDepartment, setSelectedDepartment] = useState(
    specialtyList?.department_field ? specialtyList.department_field : ""
  );
  const [selectListType, setSelectListType] = useState(
    specialtyList?.list_type ? specialtyList.list_type : ""
  );
  // selected values
  const [selectedthpc, setSelectedthpc] = useState(
    specialtyList?.thpc_nm ? specialtyList.thpc_nm : ""
  );
  const [selecteddsst, setSelecteddsst] = useState(
    specialtyList?.dsst_nm ? specialtyList.dsst_nm : ""
  );
  const [selectedindication, setSelectedindication] = useState(
    specialtyList?.indication_nm ? specialtyList.indication_nm : ""
  );
  // eslint-disable-next-line no-unused-vars
  const [selectedindicationgrp, setSelectedindicationgrp] = useState(
    specialtyList?.indication_grp_nm ? specialtyList.indication_grp_nm : ""
  );
  const [selectedbrand, setSelectedbrand] = useState(
    specialtyList?.brand_nm ? specialtyList.brand_nm : ""
  );
  const [selectedmoelcule, setSelectedmoelcule] = useState(
    specialtyList?.mdpr_nm ? specialtyList.mdpr_nm : ""
  );
  const [listQuarter, setListQuarter] = useState(
    specialtyList?.list_quarter ? specialtyList.list_quarter : ""
  );
  // search values
  const [thpcdatasearch, setthpcdatasearch] = useState([]);
  const [diseasestatesearch, setDiseasestatesearch] = useState([]);
  const [indicationnamesearch, setIndicationnamesearch] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [indicatiogrpnamesearch, setIndicatiogrpnamesearch] = useState([]);
  const [brandnamesearch, setBrandnamesearch] = useState([]);
  const [moleculesearch, setMoleculesearch] = useState([]);
  // loading values
  const [thpcloading, setThpcloading] = useState(false);
  const [dsstloading, setDsstloading] = useState(false);
  const [moleculeloading, setMoleculeloading] = useState(false);
  const [indicationloading, setIndicationloading] = useState(false);
  const [brandloading, setBrandloading] = useState(false);
  // selected values
  const [isQuarterSelected, setIsQuarterSelected] = useState(
    specialtyList?.list_quarter ? true : false
  );
  const [isThpcSelected, setIsThpcSelected] = useState(
    specialtyList?.thpc_nm ? true : false
  );
  const [isDsstSelected, setIsDsstSelected] = useState(
    specialtyList?.dsst_nm ? true : false
  );
  const [isMoleculeSelected, setIsMoleculeSelected] = useState(
    specialtyList?.mdpr_nm ? true : false
  );
  const [isIndicationSelected, setIsIndicationSelected] = useState(
    specialtyList?.indication_nm ? true : false
  );
  const [isBrandSelected, setIsBrandSelected] = useState(
    specialtyList?.brand_nm ? true : false
  );
  // next button disabled
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);
  // initial render
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [isInitialRenderlt, setIsInitialRenderlt] = useState(true);

useEffect(() => {
  const fetchDataAsync = async () => {
         await dispatch(
        FETCH_THPC_DATA({
          search_keyword: selectedthpc,
          list_type: selectListType,
          clone_type: modalType ? "existing" : "scratch",
          department_field: selectedDepartment,
        })
      );
  };
  fetchDataAsync();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [dispatch]);

  // Reset other state if selectedDepartment changes
  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      setSelectListType(specialtyList?.list_type || "");
      setSelectedthpc(specialtyList?.thpc_nm || "");
      setSelecteddsst(specialtyList?.dsst_nm || "");
      setSelectedindication(specialtyList?.indication_nm || "");
      setSelectedindicationgrp(specialtyList?.indication_grp_nm || "");
      setSelectedbrand(specialtyList?.brand_nm || "");
      setSelectedmoelcule(specialtyList?.mdpr_nm || "");
      setListQuarter(specialtyList?.list_quarter || "");
    } else {
      setSelectListType("");
      setSelectedthpc("");
      setSelecteddsst("");
      setSelectedindication("");
      setSelectedindicationgrp("");
      setSelectedbrand("");
      setSelectedmoelcule("");
      setListQuarter("");
    }
    setthpcdatasearch([]);
    setDiseasestatesearch([]);
    setIndicationnamesearch([]);
    setIndicatiogrpnamesearch([]);
    setBrandnamesearch([]);
    setMoleculesearch([]);
    setThpcloading(false);
    setDsstloading(false);
    setMoleculeloading(false);
    setIndicationloading(false);
    setBrandloading(false);
    setIsQuarterSelected(specialtyList?.list_quarter ? true : false);
    setIsThpcSelected(specialtyList?.thpc_nm ? true : false);
    setIsDsstSelected(specialtyList?.dsst_nm ? true : false);
    setIsMoleculeSelected(specialtyList?.mdpr_nm ? true : false);
    setIsIndicationSelected(specialtyList?.indication_nm ? true : false);
    setIsBrandSelected(specialtyList?.brand_nm ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment]);

  // Reset all state except selectedDepartment if selectListType changes
  useEffect(() => {
    if (isInitialRenderlt) {
      setIsInitialRenderlt(false);
      setSelectedthpc(specialtyList?.thpc_nm || "");
      setSelecteddsst(specialtyList?.dsst_nm || "");
      setSelectedindication(specialtyList?.indication_nm || "");
      setSelectedindicationgrp(specialtyList?.indication_grp_nm || "");
      setSelectedbrand(specialtyList?.brand_nm || "");
      setSelectedmoelcule(specialtyList?.mdpr_nm || "");
      setListQuarter(specialtyList?.list_quarter || "");
    } else {
      setSelectedthpc("");
      setSelecteddsst("");
      setSelectedindication("");
      setSelectedindicationgrp("");
      setSelectedbrand("");
      setSelectedmoelcule("");
      setListQuarter("");
    }

    setthpcdatasearch([]);
    setDiseasestatesearch([]);
    setIndicationnamesearch([]);
    setIndicatiogrpnamesearch([]);
    setBrandnamesearch([]);
    setMoleculesearch([]);
    setThpcloading(false);
    setDsstloading(false);
    setMoleculeloading(false);
    setIndicationloading(false);
    setBrandloading(false);
    setIsQuarterSelected(specialtyList?.list_quarter ? true : false);
    setIsThpcSelected(specialtyList?.thpc_nm ? true : false);
    setIsDsstSelected(specialtyList?.dsst_nm ? true : false);
    setIsMoleculeSelected(specialtyList?.mdpr_nm ? true : false);
    setIsIndicationSelected(specialtyList?.indication_nm ? true : false);
    setIsBrandSelected(specialtyList?.brand_nm ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectListType]);

  useEffect(() => {
    console.log("Button disable logic - checking conditions:");
    console.log("modalType:", modalType);
    console.log("selectedDepartment:", selectedDepartment);
    console.log("selectListType:", selectListType);
    console.log("quarterSelected:", checkSFRole() ? isQuarterSelected : true);
    console.log("isThpcSelected:", isThpcSelected);
    console.log("isDsstSelected:", isDsstSelected);
    console.log("isMoleculeSelected:", isMoleculeSelected);
    console.log("selectedthpc:", selectedthpc);
    console.log("selecteddsst:", selecteddsst);
    console.log("selectedmoelcule:", selectedmoelcule);
    
    // the button disabled state depends on quarter when user is hcp sf marketer or incentivized approver and brand is selected
    const quarterSelected = checkSFRole() ? isQuarterSelected : true;
    if (selectedDepartment === "MEDICAL" && selectListType === "thpconly") {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          (modalType
            ? thpcdata.some((item) => item.thpc_nm === selectedthpc)
            : thpcdata.some((item) => item.thpc_nm === selectedthpc))
        )
      );
    } else if (
      selectedDepartment === "MEDICAL" &&
      selectListType === "thpc&dsst"
    ) {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          (modalType
            ? thpcdata.some(
                (item) =>
                  item.thpc_nm === selectedthpc && item.dsst_nm === selecteddsst
              )
            : thpcdata.some(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm === selecteddsst
              ))
        )
      );
    } else if (
      selectedDepartment === "MEDICAL" &&
      selectListType === "thpc&dsst&mdpr"
    ) {
      const dataExists = modalType
        ? thpcdata.some(
            (item) =>
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          )
        : thpcdata.some(
            (item) =>
              item.thpc_nm === selectedthpc &&
              item.disease_nm === selecteddsst &&
              item.molecule_nm === selectedmoelcule
          );
      
      console.log("MEDICAL thpc&dsst&mdpr - dataExists:", dataExists);
      console.log("thpcdata length:", thpcdata.length);
      if (modalType) {
        console.log("Looking for modalType combination in thpcdata");
      } else {
        console.log("Looking for non-modalType combination in thpcdata");
      }
      
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          isMoleculeSelected &&
          dataExists
        )
      );
    } else if (
      selectedDepartment === "RETAIL" &&
      selectListType === "brnd&ind"
    ) {
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isIndicationSelected &&
          isBrandSelected &&
          isDsstSelected &&
          (modalType
            ? thpcdata.some(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.dsst_nm === selecteddsst &&
                  item.indication_nm === selectedindication &&
                  item.brand_nm === selectedbrand
              )
            : thpcdata.some(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm === selecteddsst &&
                  item.indctn_grp_nm === selectedindication &&
                  item.brnd_nm === selectedbrand
              ))
        )
      );
    } else if (
      selectedDepartment === "RETAIL" &&
      selectListType === "thpc&dsst&mdpr"
    ) {
      const dataExists = modalType
        ? thpcdata.some(
            (item) =>
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          )
        : thpcdata.some(
            (item) =>
              item.thpc_nm === selectedthpc &&
              item.disease_nm === selecteddsst &&
              item.molecule_nm === selectedmoelcule
          );
      
      console.log("RETAIL thpc&dsst&mdpr - dataExists:", dataExists);
      console.log("RETAIL thpc&dsst&mdpr - all conditions:");
      console.log("quarterSelected:", quarterSelected);
      console.log("isThpcSelected:", isThpcSelected);
      console.log("isDsstSelected:", isDsstSelected);
      console.log("isMoleculeSelected:", isMoleculeSelected);
      
      setIsNextButtonDisabled(
        !(
          quarterSelected &&
          isThpcSelected &&
          isDsstSelected &&
          isMoleculeSelected &&
          dataExists
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isBrandSelected,
    isIndicationSelected,
    isQuarterSelected,
    isThpcSelected,
    isDsstSelected,
    isMoleculeSelected,
    selectedthpc,
    selecteddsst,
    selectedindication,
    selectedbrand,
    selectedmoelcule,
    listQuarter,
    modalType,
  ]);

  useEffect(() => {
    if (selecteddsst !== "") setSelecteddsst("");
    if (selectedbrand !== "") setSelectedbrand("");
    if (selectedindication !== "") setSelectedindication("");
    if (selectedmoelcule !== "") setSelectedmoelcule("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedthpc]);

  useEffect(() => {
    if (selectedbrand !== "") setSelectedbrand("");
    if (selectedindication !== "") setSelectedindication("");
    if (selectedmoelcule !== "") setSelectedmoelcule("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selecteddsst]);

  useEffect(() => {
    if (selectedindication !== "") setSelectedindication("");
    if (selectedmoelcule !== "") setSelectedmoelcule("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedbrand]);

  useEffect(() => {
    if (selectedmoelcule !== "") setSelectedmoelcule("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedindication]);

  const checkSFRole = () => {
    // Only HCP SF Marketer can edit quarter field
    // Incentivized Approver removed - they only approve, not edit
    if (
      sessionStorage.getItem("role") === "spclty_hub_hcp_sf_marketer"
    ) {
      return true;
    }
    return false;
  };
  // eslint-disable-next-line no-unused-vars
  const checkOmnichannelAdvisorRole = () => {
    if (sessionStorage.getItem("role") === "spclty_hub_omnichannel_advisor") {
      return true;
    }
    return false;
  };

  /**
   * Gets department options based on user role
   * HCP Marketer: Only Commercial (RETAIL)
   * Omnichannel Advisor: Only Medical (MEDICAL)
   * Other roles: Both options
   */
  const getDepartmentOptions = () => {
    const role = sessionStorage.getItem("role");
    
    const allOptions = [
      {
        value: "",
        label: "Select",
      },
      {
        value: "RETAIL",
        label: "Commercial",
      },
      {
        value: "MEDICAL",
        label: "Medical",
      },
    ];

    // HCP Marketer can only edit/create Commercial lists
    if (role === "spclty_hub_hcp_marketer") {
      return [
        { value: "", label: "Select" },
        { value: "RETAIL", label: "Commercial" }
      ];
    }

    // Omnichannel Advisor can only edit/create Medical lists
    if (role === "spclty_hub_omnichannel_advisor") {
      return [
        { value: "", label: "Select" },
        { value: "MEDICAL", label: "Medical" }
      ];
    }

    // All other roles see both options
    return allOptions;
  };
  // thpc functions
  const handlethpcChange = (value) => {
    setSelectedthpc(value);
    if (value) {
      setIsThpcSelected(true);
    } else {
      setIsThpcSelected(false);
    }
  };
  const handlethpcInput = async (e) => {
    const inputValue = e.target.value;
    setSelectedthpc(inputValue);

    if (inputValue) {
      setThpcloading(true);
      await dispatch(
        FETCH_THPC_DATA({
          search_keyword: inputValue,
          list_type: selectListType,
          clone_type: modalType ? "existing" : "scratch",
          department_field: selectedDepartment,
        })
      );
      setThpcloading(false);
    } else {
      setIsThpcSelected(false);
      setthpcdatasearch([]);
    }
  };

  useEffect(() => {
    if (selectedthpc) {
      setthpcdatasearch([
        ...new Set(
          thpcdata.map((item) => item.thpc_nm).filter((value) => value !== null)
        ),
      ]);
      setIsThpcSelected(true);
    }
  }, [thpcdata, selectedthpc]);
  // dsst functions
  const handledsstChange = (value) => {
    setSelecteddsst(value);
    if (value) {
      setIsDsstSelected(true);
    } else {
      setIsDsstSelected(false);
    }
  };
  const handledsstInput = (e) => {
    if (e.target.value) {
      setDsstloading(true);
      console.log("123");
      let x = [];
      if (modalType) {
        x = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.dsst_nm &&
                  item.dsst_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.dsst_nm)
          ),
        ];
      } else {
        x = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm &&
                  item.disease_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.disease_nm)
          ),
        ];
      }
      setDiseasestatesearch(x);

      setDsstloading(false);
      setIsDsstSelected(true);
    } else {
      setIsDsstSelected(false);
    }
    setSelecteddsst(e.target.value);
  };
  // molecule functions
  const handlemoleculeChange = (value) => {
    setSelectedmoelcule(value);
    if (value) {
      setIsMoleculeSelected(true);
    } else {
      setIsMoleculeSelected(false);
    }
  };

  const handlemoleculeInput = (e) => {
    if (e.target.value) {
      setMoleculeloading(true);
      let x = [];
      if (modalType) {
        x = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.dsst_nm === selecteddsst &&
                  item.mdpr_nm &&
                  item.mdpr_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.mdpr_nm)
          ),
        ];
      } else {
        x = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm === selecteddsst &&
                  item.molecule_nm &&
                  item.molecule_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.molecule_nm)
          ),
        ];
      }
      setMoleculesearch(x);

      setMoleculeloading(false);
      setIsMoleculeSelected(true);
    } else {
      setIsMoleculeSelected(false);
    }
    setSelectedmoelcule(e.target.value);
  };
  // quarter functions
  const handleQuarter = ({ value }) => {
    setListQuarter(value);
    setIsQuarterSelected(!!value);
  };
  // indication functions
  const handleIndicationChange = (value) => {
    setSelectedindication(value);
    if (value) {
      setIsIndicationSelected(true);
    } else {
      setIsIndicationSelected(false);
    }
  };

  const handleIndicationInput = (e) => {
    if (e.target.value) {
      setIndicationloading(true);
      let filteredIndications = [];
      if (modalType) {
        filteredIndications = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.dsst_nm === selecteddsst &&
                  item.brand_nm === selectedbrand &&
                  item.indication_nm &&
                  item.indication_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.indication_nm)
          ),
        ];
      } else {
        filteredIndications = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm === selecteddsst &&
                  item.brnd_nm === selectedbrand &&
                  item.indctn_grp_nm &&
                  item.indctn_grp_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.indctn_grp_nm)
          ),
        ];
      }
      setIndicationnamesearch(filteredIndications);

      setIndicationloading(false);
    } else {
      setIndicationnamesearch([]);
    }
    setSelectedindication(e.target.value);
  };
  // brand functions
  const handleBrandChange = (value) => {
    setSelectedbrand(value);
    if (value) {
      setIsBrandSelected(true);
    } else {
      setIsBrandSelected(false);
    }
  };

  const handleBrandInput = (e) => {
    if (e.target.value) {
      setBrandloading(true);
      let filteredBrands = [];
      if (modalType) {
        filteredBrands = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.dsst_nm === selecteddsst &&
                  item.brand_nm &&
                  item.brand_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.brand_nm)
          ),
        ];
      } else {
        filteredBrands = [
          ...new Set(
            thpcdata
              .filter(
                (item) =>
                  item.thpc_nm === selectedthpc &&
                  item.disease_nm === selecteddsst &&
                  item.brnd_nm &&
                  item.brnd_nm
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
              )
              .map((item) => item.brnd_nm)
          ),
        ];
      }
      setBrandnamesearch(filteredBrands);

      setBrandloading(false);
    } else {
      setBrandnamesearch([]);
    }
    setSelectedbrand(e.target.value);
  };

  // create list
  // eslint-disable-next-line no-unused-vars
  const createNext = async () => {
    const listType = selectListType ? selectListType : "";
    let obj = {};
    if (modalType) {
      if (selectedDepartment === "RETAIL") {
        if (selectListType === "brnd&ind") {
          const uuid_old = thpcdata.find(
            (item) =>
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.indication_nm === selectedindication &&
              item.brand_nm === selectedbrand
          )?.uuid;
          obj = {
            clone_type: "existing",
            uuid_old: uuid_old,
            list_quarter: listQuarter || "",
            created_by: uuid,
            updated_by: uuid,
          };
        } else if (selectListType === "thpc&dsst&mdpr") {
          const uuid_old = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst&mdpr" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          )?.uuid;
          obj = {
            clone_type: "existing",
            uuid_old: uuid_old,
            list_quarter: listQuarter || "",
            created_by: uuid,
            updated_by: uuid,
          };
        }
      } else {
        if (selectListType === "thpconly") {
          const uuid_old = thpcdata.find(
            (item) =>
              item.list_type === "thpconly" && item.thpc_nm === selectedthpc
          )?.uuid;
          obj = {
            clone_type: "existing",
            uuid_old: uuid_old,
            list_quarter: listQuarter || "",
          };
        } else if (selectListType === "thpc&dsst") {
          const uuid_old = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst
          )?.uuid;
          obj = {
            clone_type: "existing",
            uuid_old: uuid_old,
            list_quarter: listQuarter || "",
          };
        } else if (selectListType === "thpc&dsst&mdpr") {
          const uuid_old = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst&mdpr" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          )?.uuid;
          obj = {
            clone_type: "existing",
            uuid_old: uuid_old,
            list_quarter: listQuarter || "",
          };
        }
      }
    } else {
      obj = {
        thpc_nm: selectedthpc,
        thpc_id:
          thpcdata.find((item) => item.thpc_nm === selectedthpc && item.thpc_id)
            ?.thpc_id || "",
        dsst_nm: selecteddsst,
        dsst_id: selecteddsst
          ? thpcdata.find((item) => item.disease_nm === selecteddsst)?.dsst_id
          : "",
        indication_nm: selectedindication,
        indication_id: selectedindication
          ? thpcdata.find((item) => item.indctn_grp_nm === selectedindication)
              ?.indctn_grp_id
          : "",
        // indication_grp_nm:
        //   thpcdata.find((item) => item.indctn_nm === selectedindication)
        //     ?.indctn_grp_nm || "",
        // indication_grp_id:
        //   thpcdata.find((item) => item.indctn_nm === selectedindication)
        //     ?.indctn_grp_id || "",
        brand_nm: selectedbrand,
        brand_id: selectedbrand
          ? thpcdata.find((item) => item.brnd_nm === selectedbrand)?.brnd_id
          : "",
        mdpr_nm: selectedmoelcule,
        mdpr_id: selectedmoelcule
          ? thpcdata.find((item) => item.molecule_nm === selectedmoelcule)
              ?.mdpr_id
          : "",
        list_quarter: listQuarter || "",
        list_type: listType || "",
        clone_type: modalType ? "existing" : "scratch",
        department_field: selectedDepartment,
      };
    }
    console.log("obj", obj);
    const response = await dispatch(CREATE_LIST(obj));
    console.log("response", response);
    console.log("response", response);
    if (response?.payload?.data?.data?.uuid) {
      navigate(`/details/${response.payload.data.data.uuid}`);
    } else {
      console.error("listUUID not found in response");
    }
  };

  const createMetaData = () => {
    const listType = selectListType ? selectListType : "";
    
    // Helper function to construct list title based on the selected fields and order
    const constructListTitle = () => {
      // Extract existing quarter and year from the current list title if it exists
      let existingQuarterYear = "";
      const currentTitle = specialtyList?.list_title || "";
      
      console.log("constructListTitle - currentTitle:", currentTitle);
      console.log("constructListTitle - listQuarter:", listQuarter);
      
      // Check if current title starts with year-quarter pattern or just year pattern
      // Handle formats: "2025-Q1 - ", "2025-Q1-", "2025-" (year only)
      const yearQuarterMatch = currentTitle.match(/^(\d{4}(?:-Q[1-4])?)(?:\s-\s|-)/);
      if (yearQuarterMatch) {
        existingQuarterYear = yearQuarterMatch[1];
        console.log("constructListTitle - existingQuarterYear:", existingQuarterYear);
      }
      
      // Build title parts based on the field order for the list type
      let titleParts = [];
      
      // Add THPC if selected
      if (selectedthpc) {
        titleParts.push(selectedthpc);
      }
      
      // Add DSST if selected
      if (selecteddsst) {
        titleParts.push(selecteddsst);
      }
      
      // For RETAIL brnd&ind: add Brand then Indication
      if (selectedDepartment === "RETAIL" && selectListType === "brnd&ind") {
        if (selectedbrand) {
          titleParts.push(selectedbrand);
        }
        if (selectedindication) {
          titleParts.push(selectedindication);
        }
      }
      
      // For MEDICAL or RETAIL thpc&dsst&mdpr: add Molecule
      if (selectListType === "thpc&dsst&mdpr" && selectedmoelcule) {
        titleParts.push(selectedmoelcule);
      }
      
      // Construct final title with existing quarter/year preserved
      if (existingQuarterYear) {
        // Determine the separator format used in the current title
        const usesSpacedSeparator = currentTitle.includes(" - ");
        const separator = usesSpacedSeparator ? " - " : "-";
        
        // If a new quarter is selected, preserve the year and update only the quarter
        if (listQuarter) {
          const existingYear = existingQuarterYear.match(/^(\d{4})/);
          if (existingYear) {
            // Preserve existing year, update quarter
            const updatedQuarterYear = existingYear[1] + "-" + listQuarter;
            console.log("constructListTitle - preserving year, new title:", updatedQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : ""));
            return updatedQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
          } else {
            // No year in existing, just use the new quarter
            console.log("constructListTitle - no existing year, using new quarter:", listQuarter + (titleParts.length > 0 ? separator + titleParts.join(separator) : ""));
            return listQuarter + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
          }
        } else {
          // No new quarter selected, keep existing quarter/year
          console.log("constructListTitle - keeping existing quarter/year:", existingQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : ""));
          return existingQuarterYear + (titleParts.length > 0 ? separator + titleParts.join(separator) : "");
        }
      } else {
        // If no existing quarter/year and new quarter is selected, add it
        // Default to spaced separator for new titles
        if (listQuarter) {
          console.log("constructListTitle - no existing, using new quarter:", listQuarter + (titleParts.length > 0 ? " - " + titleParts.join(" - ") : ""));
          return listQuarter + (titleParts.length > 0 ? " - " + titleParts.join(" - ") : "");
        }
        console.log("constructListTitle - no quarter info, using just title parts:", titleParts.join(" - "));
        return titleParts.join(" - ");
      }
    };

    let obj = {};
    const listTitle = constructListTitle();
    
    if (modalType) {
      if (selectedDepartment === "RETAIL") {
       if(selectListType === "brnd&ind"){
         const data = thpcdata.find(
          (item) =>
            item.thpc_nm === selectedthpc &&
            item.dsst_nm === selecteddsst &&
            item.indication_nm === selectedindication &&
            item.brand_nm === selectedbrand
        );
        obj = {
          thpc_nm: selectedthpc,
          thpc_id: data.thpc_id || "",
          dsst_nm: selecteddsst,
          dsst_id: selecteddsst ? data.dsst_id : "",
          indication_nm: selectedindication,
          indication_id: selectedindication ? data.indctn_id : "",
          indication_grp_nm: data.indctn_grp_nm || "",
          indication_grp_id: data.indctn_grp_id || "",
          brand_nm: selectedbrand,
          brand_id: selectedbrand ? data.brnd_id : "",
          mdpr_nm: selectedmoelcule,
          mdpr_id: selectedmoelcule ? data.mdpr_id : "",
          list_quarter: listQuarter || "",
          list_type: listType || "",
          list_title: listTitle,
          department_field: selectedDepartment,
          updated_by: uuid,
        };
       }else if(selectListType === "thpc&dsst&mdpr"){
        const data = thpcdata.find(
          (item) =>
            item.list_type === "thpc&dsst&mdpr" &&
            item.thpc_nm === selectedthpc &&
            item.dsst_nm === selecteddsst &&
            item.mdpr_nm === selectedmoelcule
        );
        obj = {
          thpc_nm: selectedthpc,
          thpc_id: data.thpc_id || "",
          dsst_nm: selecteddsst,
          dsst_id: selecteddsst ? data.dsst_id : "",
          indication_nm: selectedindication,
          indication_id: selectedindication ? data.indctn_id : "",
          indication_grp_nm: data.indctn_grp_nm || "",
          indication_grp_id: data.indctn_grp_id || "",
          brand_nm: selectedbrand,
          brand_id: selectedbrand ? data.brnd_id : "",
          mdpr_nm: selectedmoelcule,
          mdpr_id: selectedmoelcule ? data.mdpr_id : "",
          list_quarter: listQuarter || "",
          list_type: listType || "",
          list_title: listTitle,
          department_field: selectedDepartment,
          updated_by: uuid,
        };
       }
      } else {
        if (selectListType === "thpconly") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpconly" && item.thpc_nm === selectedthpc
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        } else if (selectListType === "thpc&dsst") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        } else if (selectListType === "thpc&dsst&mdpr") {
          const data = thpcdata.find(
            (item) =>
              item.list_type === "thpc&dsst&mdpr" &&
              item.thpc_nm === selectedthpc &&
              item.dsst_nm === selecteddsst &&
              item.mdpr_nm === selectedmoelcule
          );
          obj = {
            thpc_nm: selectedthpc,
            thpc_id: data.thpc_id || "",
            dsst_nm: selecteddsst,
            dsst_id: selecteddsst ? data.dsst_id : "",
            indication_nm: selectedindication,
            indication_id: selectedindication ? data.indctn_id : "",
            indication_grp_nm: data.indctn_grp_nm || "",
            indication_grp_id: data.indctn_grp_id || "",
            brand_nm: selectedbrand,
            brand_id: selectedbrand ? data.brnd_id : "",
            mdpr_nm: selectedmoelcule,
            mdpr_id: selectedmoelcule ? data.mdpr_id : "",
            list_quarter: listQuarter || "",
            list_type: listType || "",
            list_title: listTitle,
            department_field: selectedDepartment,
            updated_by: uuid,
          };
        }
      }
    } else {
      obj = {
        thpc_nm: selectedthpc,
        thpc_id:
          thpcdata.find((item) => item.thpc_nm === selectedthpc && item.thpc_id)
            ?.thpc_id || "",
        dsst_nm: selecteddsst,
        dsst_id: selecteddsst
          ? thpcdata.find((item) => item.disease_nm === selecteddsst)?.dsst_id
          : "",
        indication_nm: selectedindication,
        indication_id: selectedindication
          ? thpcdata.find((item) => item.indctn_grp_nm === selectedindication)
              ?.indctn_grp_id
          : "",
        // indication_grp_nm:
        //   thpcdata.find((item) => item.indctn_nm === selectedindication)
        //     ?.indctn_grp_nm || "",
        // indication_grp_id:
        //   thpcdata.find((item) => item.indctn_nm === selectedindication)
        //     ?.indctn_grp_id || "",
        brand_nm: selectedbrand,
        brand_id: selectedbrand
          ? thpcdata.find((item) => item.brnd_nm === selectedbrand)?.brnd_id
          : "",
        mdpr_nm: selectedmoelcule,
        mdpr_id: selectedmoelcule
          ? thpcdata.find((item) => item.molecule_nm === selectedmoelcule)
              ?.mdpr_id
          : "",
        list_quarter: listQuarter || "",
        list_type: listType || "",
        list_title: listTitle,
        department_field: selectedDepartment,
        updated_by: uuid,
      };
    }

    saveMetaData(obj);
  };

  return (
    <>
      <div className="row">
        <div className="col-4">
          <LdsSelect
            id="departmentSelect"
            label="Department"
            name="departmentSelect"
            value={selectedDepartment}
            options={getDepartmentOptions()}
            onChange={(option) => {
              setSelectedDepartment(option.value);
              setSelectListType("");
            }}
          />
        </div>
        {selectedDepartment === "MEDICAL" && (
          <div className="col-4">
            <LdsSelect
              id="listtype"
              label="List Type"
              name="listtype"
              value={selectListType}
              options={[
                {
                  value: "",
                  label: "Select",
                },
                {
                  value: "thpconly",
                  label: "Therapeutic Area only",
                },
                {
                  value: "thpc&dsst",
                  label: "Therapeutic Area + Disease State",
                },
                {
                  value: "thpc&dsst&mdpr",
                  label: "Therapeutic Area + Disease State + Molecule",
                },
              ]}
              onChange={(option) => {
                setSelectListType(option.value);
              }}
            />
          </div>
        )}
        {selectedDepartment === "RETAIL" && (
          <div className="col-4">
            <LdsSelect
              id="listtype"
              label="List Type"
              name="listtype"
              value={selectListType}
              options={[
                {
                  value: "",
                  label: "Select",
                },
                {
                  value: "brnd&ind",
                  label: "Therapeutic Area + Disease State + Brand + Indication",
                },
                {
                  value: "thpc&dsst&mdpr",
                  label: "Therapeutic Area + Disease State + Molecule",
                },
              ]}
              onChange={(option) => {
                setSelectListType(option.value);
              }}
            />
          </div>
        )}
      </div>
      {selectedDepartment === "MEDICAL" && (
        <div className="row mt-3">
          {selectListType && (
            <div className="col-4">
              Therapeutic Area
              <LdsSearch
                id="selectedThpc"
                name="q-type-ahead-thpc"
                isTypeAhead={true}
                value={selectedthpc}
                onChange={handlethpcChange}
                onInput={handlethpcInput}
                searchSuggestions={thpcdatasearch}
                isLoading={thpcloading}
                disabled={selectedDepartment === ""}
              />
            </div>
          )}
          {(selectListType === "thpc&dsst" ||
            selectListType === "thpc&dsst&mdpr") && (
            <div className="col-4">
              Disease State
              <LdsSearch
                id="selectedDsst"
                name="q-type-ahead-dsst"
                isTypeAhead={true}
                value={selecteddsst}
                onChange={handledsstChange}
                onInput={handledsstInput}
                searchSuggestions={diseasestatesearch}
                isLoading={moleculeloading}
                disabled={
                  !(
                    thpcdata.some((item) => item.thpc_nm === selectedthpc) ||
                    selecteddsst === specialtyList.dsst_nm
                  )
                }
              />
            </div>
          )}
          {selectListType === "thpc&dsst&mdpr" && (
            <div className="col-4">
              Molecule
              <LdsSearch
                id="selectedMolecule"
                name="q-type-ahead-molecule"
                isTypeAhead={true}
                value={selectedmoelcule}
                onChange={handlemoleculeChange}
                onInput={handlemoleculeInput}
                searchSuggestions={moleculesearch}
                isLoading={dsstloading}
                disabled={
                  modalType
                    ? !(
                        thpcdata.some(
                          (item) =>
                            item.thpc_nm === selectedthpc &&
                            item.dsst_nm === selecteddsst
                        ) || selectedmoelcule === specialtyList.mdpr_nm
                      )
                    : !(
                        thpcdata.some(
                          (item) =>
                            item.thpc_nm === selectedthpc &&
                            item.disease_nm === selecteddsst
                        ) || selectedmoelcule === specialtyList.mdpr_nm
                      )
                }
              />
            </div>
          )}

          {checkSFRole() ? (
            <div
              className={`col col-12 ${
                checkSFRole() ? "col-md-2" : "col-md-6"
              }`}
            >
              Select Quarter<sup>*</sup>
              <LdsSelect
                id="list_quarter"
                name="list_quarter"
                options={[
                  {
                    label: "Select",
                    value: "",
                  },
                  {
                    label: "Q1",
                    value: "Q1",
                  },
                  {
                    label: "Q2",
                    value: "Q2",
                  },
                  {
                    label: "Q3",
                    value: "Q3",
                  },
                  {
                    label: "Q4",
                    value: "Q4",
                  },
                ]}
                required={true}
                value={listQuarter}
                onChange={handleQuarter}
              ></LdsSelect>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
      {selectedDepartment === "RETAIL" && selectListType === "brnd&ind" && (
        <div className="row mt-3">
          <div className="col-3">
            Therapeutic Area
            <LdsSearch
              id="selectedThpc"
              name="q-type-ahead-thpc"
              isTypeAhead={true}
              value={selectedthpc}
              onChange={handlethpcChange}
              onInput={handlethpcInput}
              searchSuggestions={thpcdatasearch}
              isLoading={thpcloading}
              disabled={selectedDepartment === ""}
            />
          </div>
          <div className="col-3">
            Disease State
            <LdsSearch
              id="selectedDsst"
              name="q-type-ahead-dsst"
              isTypeAhead={true}
              value={selecteddsst}
              onChange={handledsstChange}
              onInput={handledsstInput}
              searchSuggestions={diseasestatesearch}
              isLoading={moleculeloading}
              disabled={
                !(
                  thpcdata?.some((item) => item.thpc_nm === selectedthpc) ||
                  selecteddsst === specialtyList.dsst_nm
                )
              }
            />
          </div>
          <div className="col-3">
            Brand
            <LdsSearch
              id="selectedBrand"
              name="q-type-ahead-brand"
              isTypeAhead={true}
              value={selectedbrand}
              onChange={handleBrandChange}
              onInput={handleBrandInput}
              searchSuggestions={brandnamesearch}
              isLoading={brandloading}
              disabled={
                modalType
                  ? !(
                      thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.dsst_nm === selecteddsst
                      ) || selectedbrand === specialtyList.brand_nm
                    )
                  : !(
                      thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.disease_nm === selecteddsst
                      ) || selectedbrand === specialtyList.brand_nm
                    )
              }
            />
          </div>          
          <div className="col-3">
            Indication
            <LdsSearch
              id="selectedIndication"
              name="q-type-ahead-indication"
              isTypeAhead={true}
              value={selectedindication}
              onChange={handleIndicationChange}
              onInput={handleIndicationInput}
              searchSuggestions={indicationnamesearch}
              isLoading={indicationloading}
              disabled={
                modalType
                  ? !(
                      thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.dsst_nm === selecteddsst &&
                          item.brand_nm === selectedbrand
                      ) || selectedindication === specialtyList.indication_nm
                    )
                  : !(
                      thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.disease_nm === selecteddsst &&
                          item.brnd_nm === selectedbrand
                      ) || selectedindication === specialtyList.indication_nm
                    )
              }
            />
          </div>
          {checkSFRole() ? (
            <div
              className={`col col-12 ${
                checkSFRole() ? "col-md-2" : "col-md-6"
              }`}
            >
              Select Quarter<sup>*</sup>
              <LdsSelect
                id="list_quarter"
                name="list_quarter"
                options={[
                  {
                    label: "Select",
                    value: "",
                  },
                  {
                    label: "Q1",
                    value: "Q1",
                  },
                  {
                    label: "Q2",
                    value: "Q2",
                  },
                  {
                    label: "Q3",
                    value: "Q3",
                  },
                  {
                    label: "Q4",
                    value: "Q4",
                  },
                ]}
                required={true}
                value={listQuarter}
                onChange={handleQuarter}
              ></LdsSelect>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
      {selectedDepartment === "RETAIL" &&
        selectListType === "thpc&dsst&mdpr" && (
          <div className="row mt-3">
            <div className="col-4">
              Therapeutic Area
              <LdsSearch
                id="selectedThpc"
                name="q-type-ahead-thpc"
                isTypeAhead={true}
                value={selectedthpc}
                onChange={handlethpcChange}
                onInput={handlethpcInput}
                searchSuggestions={thpcdatasearch}
                isLoading={thpcloading}
                disabled={selectedDepartment === ""}
              />
            </div>
            <div className="col-4">
              Disease State
              <LdsSearch
                id="selectedDsst"
                name="q-type-ahead-dsst"
                isTypeAhead={true}
                value={selecteddsst}
                onChange={handledsstChange}
                onInput={handledsstInput}
                searchSuggestions={diseasestatesearch}
                isLoading={moleculeloading}
                disabled={
                  !thpcdata.some((item) => item.thpc_nm === selectedthpc)
                }
              />
            </div>
            <div className="col-4">
              Molecule
              <LdsSearch
                id="selectedMolecule"
                name="q-type-ahead-molecule"
                isTypeAhead={true}
                value={selectedmoelcule}
                onChange={handlemoleculeChange}
                onInput={handlemoleculeInput}
                searchSuggestions={moleculesearch}
                isLoading={dsstloading}
                disabled={
                  modalType
                    ? !thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.dsst_nm === selecteddsst
                      )
                    : !thpcdata.some(
                        (item) =>
                          item.thpc_nm === selectedthpc &&
                          item.disease_nm === selecteddsst
                      )
                }
              />
            </div>
              {checkSFRole() ? (
            <div
              className={`col col-12 ${
                checkSFRole() ? "col-md-2" : "col-md-6"
              }`}
            >
              Select Quarter<sup>*</sup>
              <LdsSelect
                id="list_quarter"
                name="list_quarter"
                options={[
                  {
                    label: "Select",
                    value: "",
                  },
                  {
                    label: "Q1",
                    value: "Q1",
                  },
                  {
                    label: "Q2",
                    value: "Q2",
                  },
                  {
                    label: "Q3",
                    value: "Q3",
                  },
                  {
                    label: "Q4",
                    value: "Q4",
                  },
                ]}
                required={true}
                value={listQuarter}
                onChange={handleQuarter}
              ></LdsSelect>
            </div>
          ) : (
            <></>
          )}
          </div>
        )}
      <div className="row next-btn-blk">
        <div className="col col-12 col-md">
          <LdsButton
            classes={`
                    "button-icon-right ${
                      isNextButtonDisabled ? "" : "blue-btn"
                    } mrgn-rt"
                  `}
            disabled={isNextButtonDisabled}
            onClick={createMetaData}
          >
            Save
          </LdsButton>
          <LdsButton
            classes="button-icon-right blue-bdr-btn ml-2"
            onClick={closeBrandIndicationEdit}
          >
            Cancel
          </LdsButton>
        </div>
      </div>
      <LdsToast />
    </>
  );
};

export default EditBrandIndication;
